// extracted by mini-css-extract-plugin
export default {"inner":"Education_inner__tZ9a4","degree":"Education_degree__7OCT+","school":"Education_school__PHyZR","meta":"Education_meta__LE3v-","badge":"Education_badge__aJUBq"};